import type { FollowingState } from "./LineFollower";

/**
 * Compares two route-following snapshots field-wise (no reference equality).
 *
 * @param left First following state.
 * @param right Second following state.
 * @returns Whether all tracked fields are equal.
 */
export const followingStateEqual = ( left: FollowingState, right: FollowingState ): boolean => {
    return (
        left.onLine === right.onLine &&
        left.lineId === right.lineId &&
        left.heading === right.heading &&
        left.lineDirection === right.lineDirection &&
        left.speed === right.speed &&
        left.confidence === right.confidence &&
        left.lastUpdateTime === right.lastUpdateTime &&
        left.isReversed === right.isReversed &&
        left.lastDirectionChangeTime === right.lastDirectionChangeTime &&
        left.rawPosition[0] === right.rawPosition[0] &&
        left.rawPosition[1] === right.rawPosition[1] &&
        left.matchedPosition[0] === right.matchedPosition[0] &&
        left.matchedPosition[1] === right.matchedPosition[1]
    );
};
